<template>
  <div id="mythVsFactThree"></div>
</template>

<script>
export default {
  name: "MythVsFactThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        myth: "You need to post every day to grow on LinkedIn",
        fact: "Consistency matters more than frequency. 3 quality posts per week beats 7 rushed ones.",
        chip: "Myth Busted",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("mythVsFactThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const labelSize = exporting ? 22 : 22 * this.scale;
      const textSize = exporting ? 34 : 34 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;
      const vsSize = exporting ? 60 : 60 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#22c55e";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="display: flex; gap: 24px; align-items: stretch;">
              <!-- Myth side -->
              <div style="flex: 1; background: #ffffff; border-radius: 12px; padding: 28px; box-shadow: 0 2px 8px rgba(0,0,0,0.04);">
                <div style="
                  font-size: ${labelSize}px;
                  font-weight: 700;
                  color: #ef4444;
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                  margin-bottom: 16px;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                ">❌ MYTH</div>
                <div style="
                  font-size: ${textSize}px;
                  font-family: 'Playfair Display', 'Georgia', serif;
                  font-weight: 600;
                  color: #999999;
                  line-height: 1.4;
                  text-decoration: line-through;
                  text-decoration-color: #ef4444;
                ">${this.data.myth}</div>
              </div>

              <!-- VS divider -->
              <div style="
                display: flex;
                align-items: center;
                font-size: ${vsSize}px;
                font-weight: 900;
                color: #1a1a1a;
                opacity: 0.1;
              ">VS</div>

              <!-- Fact side -->
              <div style="flex: 1; background: #1a1a1a; border-radius: 12px; padding: 28px;">
                <div style="
                  font-size: ${labelSize}px;
                  font-weight: 700;
                  color: ${primaryColor};
                  text-transform: uppercase;
                  letter-spacing: 0.1em;
                  margin-bottom: 16px;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                ">✅ FACT</div>
                <div style="
                  font-size: ${textSize}px;
                  font-family: 'Playfair Display', 'Georgia', serif;
                  font-weight: 600;
                  color: #ffffff;
                  line-height: 1.4;
                ">${this.data.fact}</div>
              </div>
            </div>

            <!-- Chip -->
            <div style="display: flex; margin-top: 32px;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
